module.exports = __webpack_public_path__ + "static/img/COC2023-7.33e091a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-7.png
// module id = pndt
// module chunks = 0